import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import BrandLogo from '../components/BrandLogo';

export default function TermsPage() {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen bg-[#F9FAFB]" data-testid="terms-page">
            <nav className="bg-white border-b border-[#E5E7EB] sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2">
                        <BrandLogo size={32} />
                        <span className="text-xl font-bold text-[#0A0A0A] font-['Outfit']">GUIRETAL</span>
                    </Link>
                    <Link to="/">
                        <Button variant="ghost" size="sm" data-testid="back-home-btn">
                            <ArrowLeft className="w-4 h-4 mr-2" />
                            {t('terms.back')}
                        </Button>
                    </Link>
                </div>
            </nav>

            <article className="max-w-3xl mx-auto px-4 py-12 text-[#4B5563] [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-[#0A0A0A] [&_h2]:font-['Outfit'] [&_h2]:mt-8 [&_h2]:mb-4 [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-[#0A0A0A] [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-3 [&_p]:leading-relaxed [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_ul]:space-y-1 [&_strong]:text-[#0A0A0A] [&_strong]:font-semibold [&_hr]:border-[#E5E7EB]">
                <h1 className="text-4xl font-bold text-[#0A0A0A] font-['Outfit'] mb-2">
                    {t('terms.title')}
                </h1>
                <p className="text-sm text-[#9CA3AF] mb-10"><em>{t('terms.last_update')}</em></p>

                <section>
                    <h2>{t('terms.h1')}</h2>
                    <p><Trans i18nKey="terms.p1_a" components={{ strong: <strong /> }} /></p>
                    <p>{t('terms.p1_b')}</p>
                    <p>
                        <strong>{t('terms.company_name_ph')}</strong><br />
                        <strong>{t('terms.address_ph')}</strong><br />
                        <strong>{t('terms.contact_email_ph')}</strong>
                    </p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h2')}</h2>
                    <p>{t('terms.p2_a')}</p>
                    <p>{t('terms.p2_b')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h3')}</h2>
                    <p>{t('terms.p3_a')}</p>
                    <p>{t('terms.p3_b')}</p>
                    <ul>
                        <li>{t('terms.p3_li1')}</li>
                        <li>{t('terms.p3_li2')}</li>
                        <li>{t('terms.p3_li3')}</li>
                    </ul>
                    <p>{t('terms.p3_c')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h4')}</h2>
                    <p>{t('terms.p4_a')}</p>
                    <ul>
                        <li>{t('terms.p4_li1')}</li>
                        <li>{t('terms.p4_li2')}</li>
                        <li>{t('terms.p4_li3')}</li>
                        <li>{t('terms.p4_li4')}</li>
                        <li>{t('terms.p4_li5')}</li>
                    </ul>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h5')}</h2>
                    <p>{t('terms.p5_a')}</p>
                    <p><Trans i18nKey="terms.p5_b" components={{ strong: <strong /> }} /></p>
                    <h3>{t('terms.p5_rules')}</h3>
                    <ul>
                        <li>{t('terms.p5_li1')}</li>
                        <li>{t('terms.p5_li2')}</li>
                        <li>{t('terms.p5_li3')}</li>
                    </ul>
                    <p>{t('terms.p5_c')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h6')}</h2>
                    <p>{t('terms.p6_a')}</p>
                    <p>{t('terms.p6_b')}</p>
                    <ul>
                        <li>{t('terms.p6_li1')}</li>
                        <li>{t('terms.p6_li2')}</li>
                    </ul>
                    <p>{t('terms.p6_c')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h7')}</h2>
                    <p>{t('terms.p7_a')}</p>
                    <p>{t('terms.p7_b')}</p>
                    <ul>
                        <li>{t('terms.p7_li1')}</li>
                        <li>{t('terms.p7_li2')}</li>
                        <li>{t('terms.p7_li3')}</li>
                    </ul>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h8')}</h2>
                    <h3>{t('terms.h8_1')}</h3>
                    <p>{t('terms.p8_1_a')}</p>
                    <ul>
                        <li>{t('terms.p8_1_li1')}</li>
                        <li>{t('terms.p8_1_li2')}</li>
                        <li>{t('terms.p8_1_li3')}</li>
                    </ul>

                    <h3>{t('terms.h8_2')}</h3>
                    <p>{t('terms.p8_2_a')}</p>
                    <p>{t('terms.p8_2_b')}</p>
                    <ul>
                        <li>{t('terms.p8_2_li1')}</li>
                        <li>{t('terms.p8_2_li2')}</li>
                    </ul>
                    <p>{t('terms.p8_2_c')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h9')}</h2>
                    <p>{t('terms.p9_a')}</p>
                    <p>{t('terms.p9_b')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h10')}</h2>
                    <p>{t('terms.p10_a')}</p>
                    <p>{t('terms.p10_b')}</p>
                    <ul>
                        <li>{t('terms.p10_li1')}</li>
                        <li>{t('terms.p10_li2')}</li>
                        <li>{t('terms.p10_li3')}</li>
                    </ul>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h11')}</h2>
                    <p>{t('terms.p11_a')}</p>
                    <ul>
                        <li>{t('terms.p11_li1')}</li>
                        <li>{t('terms.p11_li2')}</li>
                        <li>{t('terms.p11_li3')}</li>
                    </ul>
                    <p>{t('terms.p11_b')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h12')}</h2>
                    <p>{t('terms.p12_a')}</p>
                    <p>{t('terms.p12_b')}</p>
                </section>

                <hr className="my-8" />

                <section>
                    <h2>{t('terms.h13')}</h2>
                    <p>{t('terms.p13_a')}</p>
                    <p><strong>{t('terms.p13_email')}</strong></p>
                </section>
            </article>

            <footer className="bg-[#0A0A0A] text-[#9CA3AF] py-8 mt-16">
                <div className="max-w-7xl mx-auto px-4 text-center text-sm">
                    {t('landing.footer_copyright')}
                </div>
            </footer>
        </div>
    );
}
